import React, { Component } from "react";
import { Spin, Row, Col, Button, Table, Pagination, Modal } from "antd";
import { getCareCitiesList, deleteCity, updateCityOrder } from "../../services";
import AddEditCityModal from "./AddEditCityModal";
import { showSuccessNotification } from "../../helpers";
import ReactDragListView from "react-drag-listview";

class CareCities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citiesList: [],
      pageNo: 1,
      perPage: 10,
      totalRecords: 0,
      isProcessing: false,
      showModal: false,
      selectedCity: null
    };
  }

  componentDidMount() {
    this.fetchCareCities();
  }

  fetchCareCities = () => {
    this.setState({ isProcessing: true });
    const { perPage, pageNo } = this.state;
    getCareCitiesList(pageNo, perPage)
      .then(response => {
        this.setState({
          citiesList: response.data.data,
          totalRecords: response?.data?.meta?.total_records
        });
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  onPageChange = pageNo => {
    this.setState({ pageNo }, () => {
      this.fetchCareCities();
    });
  };

  toggleModal = () => {
    if (this.state.showModal) {
      this.setState({ selectedCity: null });
    }
    this.setState({ showModal: !this.state.showModal });
  };

  handleDeleteCity = record => {
    Modal.confirm({
      title: `Delete Confirmation`,
      content: <div>{`Are you sure you want to delete this city?`}</div>,
      onOk: () => {
        deleteCity(record.id).then(response => {
          if (response.data.success) {
            showSuccessNotification("City deleted successfully");
            this.fetchCareCities();
          }
        });
      }
    });
  };

  handleEditCity = record => {
    const {
      name,
      latitude,
      longitude,
      order_number,
      basic_city_id
    } = record.attributes;

    const selectedCity = {
      id: record.id,
      basic_city_id,
      name,
      latitude,
      longitude,
      order_number
    };
    this.setState({ selectedCity }, () => {
      this.toggleModal();
    });
  };

  handlleUpdateOrderNumber = (fromIndex, toindex) => {
    const { citiesList } = this.state;
    const record = citiesList[fromIndex];
    const params = {
      basic_city_id: record.attributes.basic_city_id,
      order_number: toindex + 1,
      id: record.id
    };
    this.setState({ isProcessing: true });
    updateCityOrder(params).then(response => {
      if (response.data.success) {
        showSuccessNotification("Order updated");
        this.fetchCareCities();
      }
    });
  };

  render() {
    const {
      citiesList,
      totalRecords,
      pageNo,
      perPage,
      isProcessing,
      showModal,
      selectedCity
    } = this.state;
    const columns = [
      {
        title: "Name",
        align: "left",
        dataIndex: "attributes.name"
      },
      {
        title: "Latitude",
        dataIndex: "attributes.latitude"
      },
      {
        title: "Longitude",
        dataIndex: "attributes.longitude"
      },
      {
        title: "Order",
        dataIndex: "attributes.order_number"
      },
      {
        title: "Actions",
        key: "actions",
        render: record => (
          <div>
            {
              <Button
                type="default"
                shape="circle"
                icon="edit"
                className="mr-10"
                onClick={() => this.handleEditCity(record)}
              />
            }
            {
              <Button
                type="default"
                shape="circle"
                icon="delete"
                className="mr-10"
                onClick={() => this.handleDeleteCity(record)}
              />
            }
            {
              <Button
                type="default"
                shape="circle"
                icon="drag"
                className="drag-handle"
              />
            }
          </div>
        )
      }
    ];

    const that = this;
    const dragProps = {
      onDragEnd(fromIndex, toIndex) {
        that.handlleUpdateOrderNumber(fromIndex, toIndex);
        // const data = [...that.state.selectedWeeklyNews];
        // const item = data.splice(fromIndex, 1)[0];
        // data.splice(toIndex, 0, item);
        // that.setState({ selectedWeeklyNews: data });
      },
      lineClassName: "primary-colored-line",
      handleSelector: "button"
    };

    return (
      <Spin spinning={isProcessing}>
        <div className="content-container">
          <div className="backgroundWhite">
            <Row type="flex" justify="space-between" className="mb-10">
              <Col className="heading-domain">Care cities</Col>
              <Col>
                <Button type="primary" onClick={this.toggleModal}>
                  Add new city
                </Button>
              </Col>
            </Row>
            <ReactDragListView {...dragProps}>
              <Table
                pagination={false}
                dataSource={citiesList}
                columns={columns}
                rowKey="id"
              />
            </ReactDragListView>
            {totalRecords > perPage && (
              <Pagination
                className="mt-10"
                total={totalRecords}
                current={pageNo}
                onChange={this.onPageChange}
                pageSize={perPage}
                defaultCurrent={pageNo}
              />
            )}
          </div>
        </div>
        {showModal && (
          <AddEditCityModal
            showModal={showModal}
            toggleModal={this.toggleModal}
            selectedCity={selectedCity}
            callback={this.fetchCareCities}
          />
        )}
      </Spin>
    );
  }
}

export default CareCities;
